import { AppConfig } from '@ltvco/refresh-lib/ctx';
import { statesContact } from '@ltvco/refresh-lib/v2';
import { useQuery } from '@ltvco/refresh-lib/vendors';
import { useContext } from 'react';

export const useStatesContact = () => {
  const { logError } = useContext(AppConfig);
  const result = useQuery<any>({
    queryKey: ['statesContact'],
    queryFn: () => {
      return statesContact();
    },

    onError: (error) => {
      logError('Error fetching vehicle complaints', error as Error);
    },
  });

  return { ...result };
};
